import styled from "styled-components";
import { InputContainer } from "../../../components/Common/Input/styled";

export const ModalUpdateBioContainer = styled.div`
  input {
    border: 1px solid #4d4d57 !important;
  }
  ${InputContainer} {
    margin-bottom: 24px;
  }
`;
